export default __webpack_public_path__ + "b8829ce7485163418690445d930b2634.svg";